// Phase 11d.5 — 3 named testimonials shared across UniversalLanding + MarketingLandings
import PropTypes from "prop-types";
import { User } from "lucide-react";

const ITEMS = [
  {
    name: "Sarah Chen",
    title: "Founder",
    company: "Notch",
    initials: "SC",
    color: "from-rose-400 to-pink-500",
    quote: "We stopped hiring SDRs in Q3. Sellyx handles 80% of our inbound and Maya schedules demos directly to my calendar.",
  },
  {
    name: "Marcus Rivera",
    title: "CEO",
    company: "Lattice GTM",
    initials: "MR",
    color: "from-indigo-500 to-violet-600",
    quote: "The ROI math is obvious. Maya replaced 3 SDRs at a fraction of the cost — and she works weekends.",
  },
  {
    name: "Priya Patel",
    title: "Cofounder",
    company: "Stack Studios",
    initials: "PP",
    color: "from-emerald-500 to-teal-600",
    quote: "Setup took 6 minutes. By Day 2, Maya was closing demos I would have missed.",
  },
];

export function NamedTestimonials({ eyebrow = "Loved by founders" }) {
  return (
    <section className="max-w-6xl mx-auto px-4 sm:px-6 py-10 sm:py-14" data-testid="named-testimonials">
      <div className="text-[10.5px] uppercase tracking-wider text-indigo-700 font-semibold text-center">{eyebrow}</div>
      <h2 className="mt-1 text-[22px] sm:text-[24px] md:text-[28px] font-semibold tracking-tight text-slate-900 text-center max-w-2xl mx-auto px-1">Founders shipped Maya on Friday. Closed deals on Monday.</h2>
      <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-3">
        {ITEMS.map((t) => (
          <div key={t.name} className="rounded-2xl border border-slate-200 bg-white p-5 flex flex-col" data-testid={`testimonial-${t.initials}`}>
            <div className="flex items-center gap-3">
              <div className={`h-10 w-10 rounded-full bg-gradient-to-br ${t.color} text-white flex items-center justify-center font-semibold text-[12.5px] tracking-tight ring-2 ring-white shadow-sm`}>
                <User size={16} strokeWidth={1.75} />
              </div>
              <div className="min-w-0">
                <div className="text-[13px] font-semibold text-slate-900 truncate">{t.name}</div>
                <div className="text-[10.5px] text-slate-500">{t.title} · <span className="font-semibold tracking-tight text-indigo-700">{t.company}</span></div>
              </div>
            </div>
            <blockquote className="mt-3 text-[13px] italic text-slate-700 leading-relaxed flex-1">&ldquo;{t.quote}&rdquo;</blockquote>
          </div>
        ))}
      </div>
    </section>
  );
}

NamedTestimonials.propTypes = {
  eyebrow: PropTypes.string,
};
